module.exports = __webpack_public_path__ + "img/redbagbg.fb392dd4.png";